import { get } from 'lodash';
var throwRequired = function (name) {
    throw new Error(name + " is required");
};
export var parseSiteFont = function (fontObj, _a) {
    var onlyFamily = _a.onlyFamily;
    var font = fontObj.value;
    if (onlyFamily) {
        var fontFamily = fontObj.family || fontObj.fontFamily || '';
        var fontFamilyIdx = -1;
        if (fontFamily.includes(' ')) {
            fontFamilyIdx = fontObj.value.indexOf("\"" + fontFamily + "\"");
        }
        if (fontFamilyIdx === -1) {
            fontFamilyIdx = fontObj.value.indexOf(fontFamily);
        }
        font = fontObj.value.substring(fontFamilyIdx);
    }
    if (font.slice(0, 5) === 'font:') {
        font = font.slice(5);
    }
    return font.replace(/[;]+$/g, '');
};
export var getSiteFont = function (appSettings, _a) {
    var wixParam = _a.wixParam, presetFallback = _a.presetFallback, fontFallback = _a.fontFallback, onlyFamily = _a.onlyFamily;
    if (!wixParam)
        throwRequired('wixParam');
    if (!presetFallback)
        throwRequired('presetFallback');
    if (!fontFallback)
        throwRequired('fontFallback');
    var font = get(appSettings, "style.fonts." + wixParam) ||
        get(appSettings, "textPresets." + presetFallback) || { value: fontFallback };
    return parseSiteFont(font, { onlyFamily: onlyFamily });
};
